import throttle from "lodash-es/throttle"

$(() => {
  const $breakpointEl = $("[data-js-scroll-breakpoint]")

  const breakpoints = []

  $breakpointEl.each((i, el) => {
    const $link = $(el)
    const name = $link.data("js-scroll-breakpoint")
    breakpoints.push({ $link, name, visited: false })
  })

  const isInViewport = ($element) => {
    const elementTop = $element.offset().top
    const elementBottom = elementTop + $element.outerHeight()
    const viewportTop = $(window).scrollTop()
    const viewportBottom = viewportTop + $(window).height()

    return elementBottom > viewportTop && elementTop < viewportBottom
  }

  const checkVisibility = () => {
    breakpoints.forEach((b) => {
      if (!b.visited) {
        if (isInViewport(b.$link)) {
          b.visited = true
          $(document).trigger(`scroll:${b.name}`)
        }
      }
    })
  }

  $(window).on("load resize scroll", throttle(checkVisibility, 500))
})



// WEBPACK FOOTER //
// ./src/blocks/scroll/scroll.js